import { signal } from '@angular/core';

export const swipeCoord = signal<[number, number]>([0, 0]);
export const swipeTime = signal<number>(Date.now());

export function swipe(e: TouchEvent, when: 'start' | 'end'): void {
  const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
  const time = Date.now();

  if (when === 'start') {
    swipeCoord.set(coord);
    swipeTime.set(time);
  }
}
